export enum EnumIdioma {
  ES = 1,
  CA
}
